import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';

export const RightArrow = ({ fill = 'black', size = 'xsmall', className }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                className={fillStyles}
                d="M12.2559 4.41075C11.9305 4.08531 11.4028 4.08531 11.0774 4.41075C10.752 4.73619 10.752 5.26382 11.0774 5.58926L14.6548 9.16667H3.33333C2.8731 9.16667 2.5 9.53975 2.5 10C2.5 10.4603 2.8731 10.8333 3.33333 10.8333H14.6548L11.0774 14.4108C10.752 14.7362 10.752 15.2638 11.0774 15.5893C11.4028 15.9147 11.9305 15.9147 12.2559 15.5893L17.2559 10.5893C17.5813 10.2638 17.5813 9.73617 17.2559 9.41076L12.2559 4.41075Z"
            />
        </svg>
    );
};
